<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
    >
      <div v-if="value" @click="handelClick" class="todiff">{{ requireValue }}</div>
      <el-button
        @click="handelClick"
        :disabled="!isedite"
        :style="inputStyle"
        ref="component"
        :loading="submitloading"
        v-else
        >{{ this.$t('page.ACTIONS') }}
      </el-button>
    </el-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'
import PageModel from '../../models/page'

export default {
  name: 'jtTaoluRequired',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },

    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: String,
      default: '',
    },
    colId: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      val: this.value == '' ? null : this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      submitloading: false,
    }
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
    requireValue() {
      let str = ''
      if (this.value) {
        let obj = JSON.parse(this.value)
        str = obj.count
      }
      return str
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    async handelClick() {
      let config = storage.getItem(constants.GLOBAL_CONFIG)
      let { gameId, teamId, teamName } = config
      let arr = this.tag.split('|')
      let obj = {
        gameId: parseInt(gameId),
        teamId: parseInt(teamId),
        teamName: teamName,
        athleteName: arr[0],
        sex: arr[1],
        groupName: arr[2],
        birthday: arr[3],
        eventName: arr[4],
        eventName2: arr[5],
      }

      this.submitloading = true
      let data = await PageModel.getRequired(obj)
      if (data.errNo == 0) {
        let payload = data.payload
        payload.sex = arr[1]
        payload.groupName = arr[2]
        payload.birthday = arr[3]
        payload.eventName2 = arr[5]
        this.submitloading = false
        this.$emit('openRequired', payload)
      } else {
        this.submitloading = false
        this.$message.error(data.errMsg)
      }
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
  },
}
</script>

<style lang="stylus" >
.sel {
  .el-select-dropdown__wrap {
    max-height: 474px;
  }

  .el-select-dropdown__item.hover {
    background-color: #8cc5ff;
  }
}

.todiff {
  cursor: pointer;
  text-align: center;
  color: #25a4bb;
  width: 100%;
}
</style>
    